import { Button, useTheme } from '@mui/material';
import { memo, ReactNode } from 'react';

interface MultiStoreButtonProps {
  children: ReactNode;
  onClick: () => void;
}

// Azione principale dell'elenco dei centri, come il bottone "Vedi altri" dello step "dove":
// pieno e col colore primario. Un bottone outlined o text prenderebbe dal tema dell'insegna
// il colore del testo pensato per i bottoni pieni e diventerebbe illeggibile.
export const MultiStoreButton = memo(function MultiStoreButton({
  children,
  onClick,
}: MultiStoreButtonProps): JSX.Element {
  const { typography } = useTheme();

  return (
    <Button
      variant="contained"
      color="primary"
      style={{
        ...typography.contentDescription2,
        width: 'fit-content',
        fontWeight: 700,
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
});
